import layout from './DropdownMenu.html?raw';
import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import DropdownMenuViewModel from '@/Components/DropdownMenu/DropdownMenuViewModel';
import ImageType from '@/Controls/Image';
import {DisposeBehavior} from '#/DefaultViewExtensionInterfaces';

export default class DropdownMenu extends Control {
    private jQueryControl: JQuery;

    private Image = ComponentManager.getControl<typeof ImageType>('Image');
    private image: ImageType;

    public constructor(private viewModel: DropdownMenuViewModel, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        let timerId = this.applyTemplate(layout, this.jQueryControl, this.applyTemplateCallback.bind(this));
        this.triggers[timerId].then(this.widget.bind(this, null));

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: any): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'dropdownmenu',

            locator: this.viewModel.locator,

            controlIdent: this.identifier,

            visible: this.viewModel.isVisible,

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });


        const itemsContainer = this.jQueryControl.find('.dropdown-items');

        if (itemsContainer.children().length === 0)
            this.viewModel.isEnabled(false);

        this.defineSubscription(this.viewModel.isOpening, (isOpen) => {
            if (isOpen) {
                this.updateDropdownPosition();
                itemsContainer.stop().slideDown(120);
            }
            else
                itemsContainer.stop().slideUp(120);
        });
    }

    private updateDropdownPosition(): void {
        const $button = this.jQueryControl.find('.dropdown-link');
        const $dropdown = this.jQueryControl.find('.dropdown-items');
        const $parent = this.jQueryControl.parent();

        // Ermittelt die Position und Breite der Schaltfläche
        const buttonOffset = $button.offset();
        const buttonWidth = $button.outerWidth();

        // Ermittelt die Breite des Dropdowns und die Position sowie Breite des Eltern-Containers
        let dropdownWidth = $dropdown.outerWidth();
        const parentOffset = $parent.offset();
        const parentWidth = $parent.outerWidth();

        // Berechnet die obere Position des Dropdowns (mit zusätzlichem 5px-Abstand)
        let top = buttonOffset.top + $button.outerHeight() - parentOffset.top + 5;
        $dropdown.css('top', `${top}px`);

        // Überprüft, ob die Breite des Dropdowns kleiner als die der Schaltfläche ist
        if (dropdownWidth < buttonWidth) {
            // Wenn ja, setzt die Breite des Dropdowns auf die Breite der Schaltfläche
            dropdownWidth = buttonWidth;
            $dropdown.css('width', `${buttonWidth}px`);
        }
        else {
            // Berechnet die linke Position des Dropdowns
            let left = buttonOffset.left - parentOffset.left;

            // Berechnet den verfügbaren Platz rechts im Eltern-Container
            const spaceRight = parentWidth - (left + dropdownWidth);

            // Falls nicht genügend Platz rechts vorhanden ist, 
            // wird die linke Position so angepasst, dass das Dropdown rechtsbündig zur Schaltfläche ist
            if (spaceRight < 0)
                left = buttonOffset.left + buttonWidth - dropdownWidth - parentOffset.left;

            // Setzt die berechnete linke Position des Dropdowns
            $dropdown.css('left', `${left}px`);
        }
    }

    private applyTemplateCallback(): void {
        const control = this.jQueryControl;
        const link = control.find('.dropdown-link');

        if (this.viewModel.imageViewModel != null) {
            this.image = new this.Image(this.viewModel.imageViewModel);
            let tuple = this.image.getTuple();

            tuple.control.appendTo(link);
        }

        const linkStyle = this.viewModel.linkStyle;
        if (linkStyle) {
            this.applyBindings(link, {
                styles: [this.viewModel.linkStyle]
            });
        }

        this.addEventHandler('click', $(document), this.handleDocumentClick.bind(this));
    }

    private handleDocumentClick(event: JQuery.ClickEvent): void {
        // es kann sein, dass das ViewModel bereits disposed ist, ehe dieses Control disposed wurde und somit der Event-Handler noch aktiv ist
        if (this.viewModel.isDisposed)
            return;
        
        const target = event.target as HTMLElement;
        const link = this.jQueryControl.find('.dropdown-link');
        const ignoreItems = this.jQueryControl.find('.' + DropdownMenuViewModel.IGNORE_CLICK_CSSCLASS);

        let shouldClose = true;

        if (link.length > 0 && link[0].contains(target))
            shouldClose = false;

        if (ignoreItems.length > 0) {
            ignoreItems.each((i, e) => {
                if (e.contains(target)) {
                    shouldClose = false;
                    return false;
                }
                return undefined;
            });
        }

        if (shouldClose)
            this.viewModel.isOpening(false);
    }

    protected getDisposeBehavior(): DisposeBehavior {
        return "Asynchronous";
    }
}

ComponentManager.setControl('DropdownMenu', DropdownMenu, 'RADPresentation.HTMLClient.DefaultViewExtensions');